import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const generateImpressionForSelfServeInvoicing = () => EnterpriseExperiments.get('isSelfServeInvoice');
export const previewImpressionForSelfServeInvoicing = () => EnterpriseExperiments.preview('isSelfServeInvoice');

export const generateImpressionForDifferentialPricing = () => EnterpriseExperiments.get('showDifferentialPricing');
export const previewImpressionForDifferentialPricing = () => EnterpriseExperiments.preview('showDifferentialPricing');
